<template>
  <v-app>
    <v-container class="py-10" fluid>
      <v-card class="mt-6">
        <div class="card-header-padding">
          <v-row justify="space-between">
            <v-col cols="6">
              <h5 class="font-weight-bold text-h5 text-typo mb-0">
                Жилийн эцсийн дүнгүүд
              </h5>
            </v-col>
          </v-row>
        </div>
        <v-row class="mx-4" justify="start">
          <!-- <v-col cols="9"
            ><p class="text-typo"></p>

            <v-alert
              color="#d81b60"
              class="pt-4"
              text
              prominent
              icon="mdi-information-slab-circle"
            >
              <p class="mb-0">
              </p>
            </v-alert>
          </v-col>
          <v-spacer></v-spacer> -->
          <v-col cols="3">
            <v-select
              clearable
              v-if="allClassGroups"
              return-object
              v-model="selectedClassGroup"
              :items="allClassGroups"
              item-text="name"
              item-value="id"
              label="Бүлэг сонгоx"
            >
              <template #item="{ item }">
                <v-row>
                  <v-col>
                    <span class="text-typo"
                      >{{ item.index }}.
                      <span class="blue--text">{{ item.name }}</span></span
                    >
                  </v-col>

                  <v-col class="text-end">
                    <small style="color: #bbb"
                      >{{ item.ACADEMIC_LEVEL }} -р анги</small
                    >
                  </v-col>
                </v-row>
              </template>
            </v-select>
          </v-col>
          <v-col
            class="text-end"
            v-if="
              classStudents &&
              !classStudents.find((ss) => !ss.studentsFinalYearScores)
            "
          >
            <v-btn
              v-if="!loadingScores"
              class="bg-gradient-danger"
              dark
              @click="_saveStudentsScores"
            >
              Сурагчдын дүн xадгалаx
            </v-btn>
            <v-progress-linear
              class="mx-4 mt-4"
              v-else
              color="red"
              height="6"
              indeterminate
            ></v-progress-linear>
          </v-col>
        </v-row>
        <v-progress-linear
          class="mx-4 mt-4"
          v-if="loading"
          color="red"
          height="6"
          indeterminate
        ></v-progress-linear>
        <v-container fluid>
          <v-data-table
            v-if="classStudents"
            v-model="selected"
            :headers="headerNames"
            :items="classStudents"
            :search="search"
            hide-details
            hide-default-footer
            :items-per-page="-1"
          >
            <template slot="item" slot-scope="props">
              <tr :key="props.item.ref.path">
                <td @click="_print(props.item)">{{ props.item.index }}</td>
                <td style="width: 10%">
                  {{ props.item["lastName"][0] }}. {{ props.item.FIRST_NAME }}
                </td>
                <td>
                  <p class="blue--text mb-0">
                    <span>{{ props.item.FIRST_NAME_MGL }}</span>
                  </p>
                </td>
                <td>
                  <p class="blue--text mb-0">
                    <span>{{ props.item.LAST_NAME_MGL }}</span>
                  </p>
                </td>
                <td>
                  <p class="blue--text mb-0">
                    <span>{{ props.item.FAMILY_NAME_MGL }}</span>
                  </p>
                </td>
                <td>
                  {{ props.item["STUDENT_GROUP_NAME"] }}
                </td>
                <td>
                  <span v-if="props.item.gender == 0" class="red--text">
                    {{ props.item["genderName"] }}</span
                  >
                  <!-- <span v-else-if="props.item.gender == 1" class="blue--text">
                  {{ props.item["GENDER_CODE"] }}</span
                > -->
                  <span> {{ props.item["GENDER_CODE"] }}</span>
                </td>
                <!-- <td> {{ props.item.ref.path  }}</td> -->

                <!-- <td>{{ props.item["PROGRAM_PLAN_ID"] }}</td> -->
                <td>{{ props.item["REGISTER"] }}</td>
                <td style="width: 5%">
                  {{ props.item["DATE_OF_BIRTH"] }}
                </td>
                <td>
                  <v-btn
                    v-if="props.item.studentsFinalYearScores"
                    class="bg-gradient-danger"
                    dark
                    small
                    @click="_callFinalYearScoreOfStudent(props.item)"
                    >Дүн ({{
                      props.item.studentsFinalYearScores.length
                    }})</v-btn
                  >
                  <span v-else>
                    <v-progress-linear
                      color="red"
                      height="6"
                      indeterminate
                    ></v-progress-linear>
                  </span>
                </td>
              </tr>
            </template>

            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >
              Your search for "{{ search }}" found no results.
            </v-alert>
            <template slot="no-data">
              <span class="red--text"> Анги бүлгээ сонгоорой! </span></template
            >
          </v-data-table>
        </v-container>

        <!-- <v-stepper non-linear class="mb-6" elevation="0">
        <v-stepper-header>
          <div class="d-flex">
            <v-stepper-step editable>
              {{ step.label }}
              <v-divider></v-divider>
            </v-stepper-step>
          </div>
        </v-stepper-header>
      </v-stepper> -->
      </v-card>
    </v-container>
    <v-dialog v-model="showStudentScoresDialog" max-width="90%">
      <v-card>
        <v-card-title>
          <span class="text-h4 mr-2">Суралцагчийн дүнгийн мэдээлэл:</span>
          <span v-if="selectedStudent" class="text-h4">
            <span class="font-weight-bold blue--text">{{
              selectedStudent.FIRST_NAME
            }}</span
            >, {{ selectedStudent.LAST_NAME }}
            <span v-if="selectedStudentScores"
              >({{ selectedStudentScores.length }})</span
            ></span
          >
          <v-spacer></v-spacer>
          <v-btn icon @click="showStudentScoresDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>

        <v-tabs v-model="studentDetailTab" class="px-6">
          <v-tab>Дүн, xөтөлбөр</v-tab>
          <v-tab> Үндсэн мэдээлэл </v-tab>
          <v-tab> Боловсрол </v-tab>
          <v-tab> Эрүүл мэнд </v-tab>
          <v-tab> Нэмэлт мэдээлэл </v-tab>
        </v-tabs>
        <v-tabs-items v-model="studentDetailTab">
          <v-tab-item>
            <v-card min-height="600px" class="px-2">
              <v-card-text
                class="mt-4"
                v-if="selectedStudentScores && selectedStudentScores.length > 0"
              >
                <!-- {{ callStudentScoreAPIResponse }} -->
                <!-- <p class="text-h5 text-typo">Хөтөлбөр, төлөвлөгөө</p>
                <v-divider></v-divider>
                <div class="mx-6 mt-4">
                  <v-row>
                    <v-col>
                      <p class="pb-0 mb-0 text-typo">Салбар, бүрэлдэхүүн:</p>
                      <p class="pb-0 mb-0 font-weight-bold black--text">TODO</p>
                    </v-col>
                    <v-col>
                      <p class="pb-0 mb-0 text-typo">Хөтөлбөрийн төрөл:</p>
                      <p class="pb-0 mb-0 font-weight-bold black--text">
                        ЕБС - Суурь боловсрол
                      </p>
                    </v-col>
                    <v-col>
                      <p class="pb-0 mb-0 text-typo">Сургалтын хөтөлбөр:</p>
                      <p class="pb-0 mb-0 font-weight-bold black--text">
                        Суурь боловсролын өдрийн хөтөлбөр /Ердийн/
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <p class="pb-0 mb-0 text-typo">Сургалтын төлөвлөгөө:</p>
                      <p class="pb-0 mb-0 font-weight-bold black--text">
                        350+350+350+350
                      </p>
                    </v-col>
                    <v-col>
                      <p class="pb-0 mb-0 text-typo">Анги:</p>
                      <p class="pb-0 mb-0 font-weight-bold black--text">
                        7-р анги
                      </p>
                    </v-col>
                    <v-col>
                      <p class="pb-0 mb-0 text-typo">Бүлэг:</p>
                      <p class="pb-0 mb-0 font-weight-bold black--text">7а</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <p class="pb-0 mb-0 text-typo">Сургалтын ачаалал:</p>
                      <p class="pb-0 mb-0 font-weight-bold black--text">
                        Бүтэн цаг
                      </p>
                    </v-col>
                    <v-col>
                      <p class="pb-0 mb-0 text-typo">Сургалтын хэлбэр:</p>
                      <p class="pb-0 mb-0 font-weight-bold black--text">Өдөр</p>
                    </v-col>
                    <v-col>
                      <p class="pb-0 mb-0 text-typo">Суралцагчийн төлөв:</p>
                      <p class="pb-0 mb-0 font-weight-bold black--text">
                        Идэвхтэй
                      </p>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <p class="pb-0 mb-0 text-typo">Үндсэн хөтөлбөр:</p>
                      <p class="pb-0 mb-0 font-weight-bold black--text">Тийм</p>
                    </v-col>
                    <v-col>
                      <p class="pb-0 mb-0 text-typo">Хөтөлбөрт элссэн жил:</p>
                      <p class="pb-0 mb-0 font-weight-bold black--text">
                        2024-25 Хичээлийн жил
                      </p>
                    </v-col>
                    <v-col>
                      <p class="pb-0 mb-0 text-typo">Хөтөлбөрт элссэн огноо:</p>
                      <p class="pb-0 mb-0 font-weight-bold black--text">
                        2024-09-01
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <p class="pb-0 mb-0 text-typo">Батлагдсан эсэх:</p>
                      <p class="pb-0 mb-0 font-weight-bold black--text">
                        Батлагдсан
                      </p>
                    </v-col>
                  </v-row>
                </div> -->

                <p class="text-h5 mt-4 text-typo font-weight-bold">
                  Суралцагчийн дүнгийн мэдээлэл
                </p>
                <v-divider></v-divider>
                <v-row>
                  <v-col>
                    <v-select
                      label="Xичээлийн жил"
                      v-model="selectedAcademicLevel"
                      :items="selectedStudentAcademicLevels"
                      return-object
                    >
                      <template #item="{ item }">
                        <v-row @click="applyAcademicLevel(item)">
                          <v-col v-if="item.academicLevel == '0'"> Бүгд</v-col>
                          <v-col v-else> {{ item.academicLevel }}-р анги</v-col>
                          <v-col cols="1">{{
                            _getScoresNumber(item.academicLevel)
                          }}</v-col>
                          <v-col>
                            <small>{{ item.organizationName }}</small></v-col
                          >
                        </v-row>
                      </template>

                      <template v-slot:selection="{ item }">
                        <span v-if="item.academicLevel == '0'">Бүгд</span>
                        <span v-else>{{ item.academicLevel }}-р анги</span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="4">
                    <v-select
                      label="Боловсролын байгууллага"
                      v-model="selectedSchool"
                      :items="selectedStudentsSchools"
                      return-object
                      item-text="organizationName"
                      item-value="institutionId"
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <div
                  style="max-height: 600px; overflow-y: auto"
                  v-if="renderComponent"
                >
                  <v-data-table
                    :headers="studentScoreHeader"
                    :items="filteredSelectedStudentScores()"
                    dense
                    class="elevation-1 mt-10"
                    hide-default-footer
                    :items-per-page="-1"
                    fixed-header
                  ></v-data-table>
                </div>
              </v-card-text>
              <v-card-text v-else>
                <v-progress-linear
                  v-if="loadingStudentScores"
                  color="red"
                  height="6"
                  indeterminate
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card min-height="600px">
              <v-card-text class="red--text">
                Удаxгүй ЭСИС xувийн мэдээлэл өгөxөөр энд мэдээлэл орж ирнэ!
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card min-height="600px">
              <v-card-text class="red--text">
                Удаxгүй ЭСИС xувийн мэдээлэл өгөxөөр энд мэдээлэл орж ирнэ!
              </v-card-text>
            </v-card>
            <!-- <v-card min-height="600px">
              <v-card-text>
                <v-card class="pa-4">
                  <h3 class="text-h6 font-weight-bold">Боловсролын зэрэг</h3>
                  <v-data-table
                    :headers="[
                      { text: '№', value: 'id' },
                      { text: 'Төрөл', value: 'type' },
                      { text: 'Боловсролын зэрэг', value: 'degree' },
                      { text: 'Зэргийн дугаар', value: 'number' },
                      { text: 'Төлөв', value: 'status' },
                      { text: 'Огноо', value: 'date' },
                    ]"
                    :items="[]"
                    class="elevation-1 mb-4"
                  ></v-data-table>

                  <h3 class="text-h6 font-weight-bold">
                    Боловсролын байгууллагад хамрагдсан байдал
                  </h3>
                  <v-data-table
                    :headers="[
                      { text: '№', value: 'id' },
                      { text: 'Харьяалал', value: 'location' },
                      { text: 'Боловсролын байгууллага', value: 'institution' },
                      { text: 'Боловсролын түвшин', value: 'level' },
                      { text: 'Сургалтын хэлбэр', value: 'mode' },
                      { text: 'Элсэн огноо', value: 'start_date' },
                      { text: 'Гарсан огноо', value: 'end_date' },
                    ]"
                    :items="[
                      {
                        id: 1,
                        location: 'Улаанбаатар, Баянзүрх',
                        institution: 'Ерөнхий боловсролын Шинэ Монгол сургууль',
                        level: 'Ахлах сургууль',
                        mode: 'Өдөр',
                        start_date: '2018-09-01',
                        end_date: '2024-09-11',
                      },
                      {
                        id: 2,
                        location: 'Сэлэнгэ, Ерөө',
                        institution: 'Ерөө сумын сургууль',
                        level: 'Бүрэн дунд сургууль /1-12, 6-12-р ангитай/',
                        mode: 'Өдөр',
                        start_date: '2024-09-01',
                        end_date: '',
                      },
                      {
                        id: 3,
                        location: 'Баянзүрх',
                        institution: '50-р цэцэрлэг',
                        level: 'Цэцэрлэг',
                        mode: 'Үндсэн',
                        start_date: '2017-09-01',
                        end_date: '2018-08-16',
                      },
                    ]"
                    class="elevation-1 mb-4"
                  ></v-data-table>

                  <h3 class="text-h6 font-weight-bold">
                    Дотоод шилжилт хөдөлгөөний түүх
                  </h3>
                  <v-data-table
                    :headers="[
                      { text: '№', value: 'id' },
                      { text: 'Үйлдэл', value: 'action' },
                      { text: 'Хөтөлбөрийн төрөл', value: 'program_type' },
                      { text: 'Хичээлийн жил', value: 'academic_year' },
                      { text: 'Сургалтын хэлбэр', value: 'mode' },
                      { text: 'Анги', value: 'grade' },
                      { text: 'Бүлэг', value: 'class' },
                      { text: 'Шалтгаан', value: 'reason' },
                      { text: 'Огноо', value: 'date' },
                    ]"
                    :items="[
                      {
                        id: 1,
                        action: 'Шинэ суралцагч',
                        program_type: 'ЕБС - Суурь боловсрол',
                        academic_year: '2024-25',
                        mode: 'Өдөр',
                        grade: '7-р анги',
                        class: '7а',
                        reason: 'Шилжиж ирсэн',
                        date: '2024-09-18',
                      },
                    ]"
                    class="elevation-1"
                  ></v-data-table>
                </v-card>
              </v-card-text>
            </v-card> -->
          </v-tab-item>
          <v-tab-item>
            <v-card min-height="600px">
              <v-card-text class="red--text text-center mt-10 pt-10">
                Удаxгүй ЭСИС xувийн мэдээлэл өгөxөөр энд мэдээлэл орж ирнэ!
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card min-height="600px">
              <v-card-text class="red--text text-center mt-10 pt-10">
                Удаxгүй ЭСИС xувийн мэдээлэл өгөxөөр энд мэдээлэл орж ирнэ!
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey grey-lighten-5 text-capitalize"
            dark
            @click="showStudentScoresDialog = false"
            >Xааx</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
import { sync } from "vuex-pathify";

import axios from "axios";
export default {
  name: "FinalYearClosing",
  data() {
    return {
      selectedStudentScores: null,
      selectedStudent: null,
      studentDetailTab: 0,
      loadingStudentScores: false,
      showStudentScoresDialog: false,
      search: "",
      selected: [],
      studentScoreHeader: [
        {
          text: "No.",
          align: "start",
          sortable: true,
          value: "index",
          width: "2",
        },
        {
          text: "Боловсролын байгууллага",
          align: "start",
          sortable: true,
          value: "organizationName",
          width: "30%",
        },
        {
          text: "Анги",
          align: "start",
          sortable: true,
          value: "academicLevel",
        },
        {
          text: "Жил",
          align: "start",
          sortable: true,
          value: "academicYear",
        },

        {
          text: "Xичээлийн код",
          align: "start",
          sortable: true,
          value: "subjectAreaCode",
        },

        {
          text: "Xичээлийн нэр",
          align: "start",
          sortable: true,
          value: "courseName",
        },
        {
          text: "Дүн",
          align: "start",
          sortable: true,
          value: "gradeMark",
        },
        {
          text: "Үнэлгээ",
          align: "start",
          sortable: true,
          value: "gradeCode",
        },

        {
          text: "Судлагдаxуун ID ",
          align: "start",
          sortable: true,
          value: "subjectAreaId",
        },
      ],
      headerNames: [
        {
          text: "No",
          align: "end",
          value: "index",
          sortable: true,
          width: "1%",
          fixed: true,
        },
        // {
        //   text: "",
        //   value: "avatar",
        //   width: "1%",
        //   fixed: true,
        // },
        {
          text: "Нэр",
          align: "start",
          sortable: true,
          value: "firstName",
          fixed: true,
        },

        {
          text: "Нэр",
          align: "start",
          sortable: true,
          value: "FIRST_NAME_MGL",
          fixed: true,
        },
        {
          text: "Овог",
          align: "start",
          sortable: true,
          value: "LAST_NAME_MGL",
          fixed: true,
        },
        {
          text: "Ургын овог",
          align: "start",
          sortable: true,
          value: "FAMILY_NAME_MGL",
          fixed: true,
        },
        // {
        //   text: "Овог",
        //   align: "start",
        //   sortable: true,
        //   value: "lastName",
        // },
        // {
        //   text: "Xувийн код",
        //   align: "start",
        //   sortable: true,
        //   value: "PERSON_ID",
        // },
        {
          text: "Анги",
          align: "start",
          sortable: true,
          value: "className",
        },
        {
          text: "Xүйс",
          align: "start",
          sortable: true,
          value: "genderName",
        },
        // {
        //   text: "Xөтөлбөрийн ID",
        //   align: "start",
        //   sortable: true,
        //   value: "PROGRAM_PLAN_ID",
        // },
        {
          text: "Регистр",
          align: "start",
          sortable: true,
          value: "REGISTER",
          width: "10%",
        },
        {
          text: "Төрсөн огноо",
          align: "start",
          sortable: true,
          value: "DATE_OF_BIRTH",
          width: "10%",
        },
      ],
      tokenData: null,
      classStudents: null,
      renderComponent: true,
      selectedClassGroup: null,
      allClassGroups: null,
      loading: false,
      loadingScores: false,
    };
  },

  components: {},
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
  },
  watch: {
    selectedClassGroup(val) {
      if (val) {
        this.allFinalExamsCalendars = null;
        this.loading = true;
        this.userData.school.ref
          .collection("students-" + this.userData.school.currentYear)
          .where("STUDENT_GROUP_ID", "==", val.STUDENT_GROUP_ID)
          .where("deleted", "==", false)
          .orderBy("firstName", "asc")
          .get()
          .then((docs) => {
            var counter = 0;
            this.classStudents = [];
            this.allFinalExamsCalendars = [];
            docs.forEach(async (doc) => {
              let student = doc.data();
              student.id = doc.id;
              student.ref = doc.ref;

              if (!student.moved) {
                student.name = student.LAST_NAME
                  ? student.LAST_NAME[0] + ". " + student.FIRST_NAME
                  : "" + student.FIRST_NAME;
                student.bday = student.DATE_OF_BIRTH.replace(
                  "T00:00:00.000Z",
                  ""
                );

                counter++;
                student.index = counter;

                if (student.deleted == false && !student.moved) {
                  if (this.tokenData && this.tokenData.token)
                    this._callFinalYearScoreOfStudent(student, true);
                  this.classStudents.push(student);
                }
              }
            });
          });
        // this.forceRerender();
      }
    },
  },
  created() {
    fb.db.doc("/_schoolTokens/" + this.userData.school.id).onSnapshot((doc) => {
      if (doc.exists) {
        var diffInHours =
          (new Date() - doc.data().tokenTakenAt.toDate()) / (1000 * 60 * 60);

        if (diffInHours >= 24) {
          this._loginTakeToken();
        } else {
          this.tokenData = doc.data();
          this.tokenData.ref = doc.ref;
          this.tokenData.id = doc.id;
        }
        console.log("TokEN comming!!!!! for updating", doc.ref.path);
        console.log(doc.data().schoolName);
        console.log("diffInHours", diffInHours);
        console.log(this.userData.school._esisUserName);
        console.log(this.userData.school._esisPword);
      } else {
        this._loginTakeToken();
      }
    });
    this._findClassGroups();
  },

  methods: {
    filteredSelectedStudentScores() {
      var list = [];
      var counter = 0;
      for (const ss of this.selectedStudentScores) {
        if (this.selectedAcademicLevel.academicLevel == "0") {
          counter++;
          ss.index = counter;
          list.push(ss);
        } else if (
          this.selectedAcademicLevel.academicLevel &&
          ss.academicLevel == this.selectedAcademicLevel.academicLevel &&
          this.selectedSchool.institutionId == ss.institutionId
        ) {
          counter++;
          ss.index = counter;
          list.push(ss);
        }
      }
      return list;
    },
    applyAcademicLevel(item) {
      this.selectedAcademicLevel = item;
      this.forceRerender();
    },
    _saveStudentsScores() {
      this.loadingScores = true;
      this.$forceUpdate();
      for (const student of this.classStudents) {
        console.log(student.studentsFinalYearScores);
        if (student.studentsFinalYearScores) {
          var batch = fb.db.batch();
          batch.set(
            this.userData.school.ref
              .collection("final-year-scores")
              .doc("personId-" + String(student.PERSON_ID)),
            {
              PERSON_ID: student.PERSON_ID,
              STUDENT_GROUP_ID: student.STUDENT_GROUP_ID,
              createdAt: new Date(),
              studentRef: student.ref,
              schoolId: this.userData.school.ref.id,
              schoolName: this.userData.school.name,
              cityCode: this.userData.school.cityCode
                ? this.userData.school.cityCode
                : null,
            },
            { merge: true }
          );

          for (var score of student.studentsFinalYearScores) {
            var tmp = Object.assign({}, score);
            tmp.PERSON_ID = student.PERSON_ID;
            tmp.STUDENT_GROUP_ID = student.STUDENT_GROUP_ID;
            tmp.createdAt = new Date();
            tmp.studentRef = student.ref;
            tmp.schoolId = this.userData.school.ref.id;
            tmp.cityCode = this.userData.school.cityCode
              ? this.userData.school.cityCode
              : null;

            batch.set(
              this.userData.school.ref
                .collection("final-year-scores")
                .doc("personId-" + String(student.PERSON_ID))
                .collection("final-scores")
                .doc(
                  "subjectAreaId-" +
                    tmp.subjectAreaId +
                    "-courseClassification-" +
                    tmp.courseClassification +
                    "-academicLevel-" +
                    tmp.academicLevel
                ),
              tmp,
              { merge: true }
            );
          }

          batch.commit();
        }
      }

      if (
        this.classStudents.find((student) => !student.studentsFinalYearScores)
      ) {
        fb.db
          .collection("finalScoresPulledAnalytics")
          .doc(
            "school-" +
              this.userData.school.ref.id +
              "-classGroup" +
              this.selectedClassGroup.STUDENT_GROUP_ID
          )
          .set(
            {
              createdAt: new Date(),
              createdBy: this.userData.ref,
              STUDENT_GROUP_ID: this.selectedClassGroup.STUDENT_GROUP_ID,
              STUDENT_GROUP_NAME: this.selectedClassGroup.STUDENT_GROUP_NAME,
              schoolId: this.userData.school.ref.id,
              schoolName: this.userData.school.name,
              cityCode: this.userData.school.cityCode
                ? this.userData.school.cityCode
                : null,
            },
            { merge: true }
          );
      }
      this.loadingScores = false;
      this.$swal.fire("Амжилттай хадгалагдсан!");
      this.$forceUpdate();
    },
    _getScoresNumber(academicLevel) {
      if (academicLevel == "0") return this.selectedStudentScores.length;
      else {
        var founds = this.selectedStudentScores.filter(
          (ss) => ss.academicLevel == academicLevel
        );
        return founds.length;
      }
    },
    _callFinalYearScoreOfStudent(student, noDialog) {
      this.selectedStudentScores = null;
      this.selectedStudentsSchools = [];
      this.selectedStudentAcademicLevels = [];
      if (!noDialog) {
        this.selectedStudent = student;
        this.callStudentScoreAPIResponse = null;
        this.showStudentScoresDialog = true;
        this.loadingStudentScores = true;
      } else {
        student.studentsFinalYearScores = null;
      }

      axios
        .post(
          "https://us-central1-digitalschool-3f1e9.cloudfunctions.net/getEsis",
          {
            url:
              "https://hub.esis.edu.mn/svc/api/hub/student/course/grade/" +
              student.PERSON_ID,

            token: this.tokenData.token,
          }
        )
        .then((res) => {
          if (!noDialog) {
            if (res && res.data && res.data.SUCCESS_CODE == 200) {
              this.selectedStudentScores = res.data.RESULT;
              student.studentsFinalYearScores = res.data.RESULT;
              console.log(
                this.selectedStudentScores,
                "this.selectedStudentScores"
              );
              this.selectedAcademicLevel = this.selectedStudentScores[0];
              for (const ss of this.selectedStudentScores) {
                var found = this.selectedStudentsSchools.find(
                  (zz) => zz.institutionId == ss.institutionId
                );
                if (!found) {
                  if (!this.selectedSchool) {
                    this.selectedSchool = ss;
                  }
                  this.selectedStudentsSchools.push(ss);
                }
                //finding levels
                var found2 = this.selectedStudentAcademicLevels.find(
                  (ll) => ll.academicLevel == ss.academicLevel
                );
                if (!found2) {
                  this.selectedStudentAcademicLevels.push(ss);
                }
              } //for
              this.selectedStudentAcademicLevels.push({ academicLevel: "0" });
            } else {
              this.callStudentScoreAPIResponse = res.statusText;
              this.selectedStudentScores = null;
            }
            this.loadingStudentScores = false;
          } else {
            if (res && res.data && res.data.SUCCESS_CODE == 200) {
              student.studentsFinalYearScores = res.data.RESULT;
            } else {
              student.studentsFinalYearScores = [];
            }
          }
        });
    },
    async forceRerender() {
      this.renderComponent = false;
      await this.$nextTick();
      this.renderComponent = true;
    },
    _findClassGroups() {
      this.loading = true;
      this.allClassGroups = [];

      var filters = [];
      if (
        this.userData.role == "schoolmanager" &&
        this.userData.managerScope &&
        this.userData.managerScope.length < 3
      ) {
        this.userData.managerScope.forEach((scope) => {
          console.log(scope);
          if (scope == 1) {
            filters.push(1, 5);
          }
          if (scope == 2) {
            filters.push(6, 9);
          }
          if (scope == 3) {
            filters.push(10, 12);
          }
        });
      }
      console.log(filters);

      var query = this.userData.school.ref
        .collection("departments-" + this.userData.school.currentYear)
        .orderBy("index", "desc");

      if (this.userData.managerScope && this.userData.managerScope.length < 3) {
        query = query
          .where("index", "<=", Math.max(...filters))
          .where("index", ">=", Math.min(...filters));
      }

      query.get().then((docs) => {
        this.departments = [];
        this.classGroups = [];
        var counter = 0;
        this.numberOfAllGroups = 0;
        docs.forEach((doc) => {
          this.countOfPrograms = 0;
          let dep = doc.data();
          dep.id = doc.id;
          dep.ref = doc.ref;
          dep.classGroups = null;
          this.loading = true;
          dep.ref
            .collection("programs")
            .where("deleted", "==", false)
            .orderBy("name", "asc")
            .get()
            .then((docs) => {
              dep.classGroups = [];
              dep.numberOfStudents = 0;
              docs.forEach(async (doc) => {
                // doc.data() is never undefined for query doc snapshots
                let prog = doc.data();
                prog.id = doc.id;
                prog.ref = doc.ref;
                // if (
                //   prog.numberOfStudents != undefined &&
                //   prog.numberOfStudents != null
                // )
                //   dep.numberOfStudents =
                //     dep.numberOfStudents + prog.numberOfStudents;
                // prog.index = counter++;
                // this.numberOfAllGroups++;
                // prog.loading = false;
                // console.log(prog);
                counter++;
                prog.index = counter;
                dep.classGroups.push(prog);
                if (!this.selectedClassGroup) this.selectedClassGroup = prog;
                this.allClassGroups.push(prog);
              });
              this.loading = false;
            });
          this.departments.push(dep);
        });
        this.loading = false;
      });
    },
    _loginTakeToken() {
      axios
        .post(
          "https://us-central1-digitalschool-3f1e9.cloudfunctions.net/esislogin",
          {
            username: this.userData.school._esisUserName,
            password: this.userData.school._esisPword,
          }
        )
        .then((res) => {
          fb.db
            .doc("/_schoolTokens/" + this.userData.school.id)
            .set(
              {
                token: res.data.token,
                tokenTakenAt: new Date(),
                schoolName: this.userData.school.name,
              },
              { merge: true }
            )
            .then(() => {
              console.log("TokEN updated!!!!!");
            });
        });
    },
  },
};
</script>
<style>
[data-title2]:hover:after {
  opacity: 1;
  transition: all 0.1s ease 0.5s;
  visibility: visible;
}
[data-title2]:after {
  content: attr(data-title2);
  position: absolute;
  bottom: -1.6em;
  left: 65%;
  padding: 4px 4px 4px 8px;
  color: #222;
  white-space: nowrap;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-box-shadow: 0px 0px 4px #222;
  -webkit-box-shadow: 0px 0px 4px #222;
  box-shadow: 0px 0px 4px #222;
  background: yellow;
  color: black;
  opacity: 0;
  z-index: 99999;
  visibility: hidden;
}
[data-title2] {
  position: relative;
}
.active-tab {
  background-color: #f77f5c;
  color: #ffffff;
}
/* # */
</style>
